// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"d82eda72","267":"03363f54","440":"20ff2f06","453":"258b012d"}[chunkId] + ".chunk.js";
};